import React, { FC, useMemo } from 'react';
import { BaseWrapper } from 'styles/common';
import { IAccordionItem } from 'kl-b2c-ui-kit';
import PrimaryAccordion from 'components/accordion/PrimaryAccordion';
import { EQUIPMENT_DATA } from 'consts';
import {
    EquipmentWrapper,
    Title,
    DesktopGrid,
    MobileAccordionContainer,
    Card,
    CardHeader,
    CardIcon,
    CardTitle,
    List,
    ListItem,
    AccordionTitleWrapper,
} from './styled';
import { useTranslation } from 'react-i18next';

const Equipment: FC = () => {
    const { t } = useTranslation('pages/home');

    const mobileAccordionItems: IAccordionItem[] = useMemo(
        () =>
            EQUIPMENT_DATA.map((data) => ({
                key: data.id,
                title: (
                    <AccordionTitleWrapper>
                        <CardIcon src={data.icon} alt={data.title} />
                        <CardTitle>{data.title}</CardTitle>
                    </AccordionTitleWrapper>
                ),
                body: (
                    <List>
                        {data.items.map((item, index) => (
                            <ListItem key={`${data.id}-${index}`}>{item}</ListItem>
                        ))}
                    </List>
                ),
            })),
        []
    );

    return (
        <BaseWrapper>
            <EquipmentWrapper>
                <Title>{t('equipment-title')}</Title>

                <DesktopGrid>
                    {EQUIPMENT_DATA.map((data) => (
                        <Card key={data.id}>
                            <CardHeader>
                                <CardIcon src={data.icon} alt={data.title} />
                                <CardTitle>{data.title}</CardTitle>
                            </CardHeader>
                            <List>
                                {data.items.map((item, index) => (
                                    <ListItem key={`${data.id}-${index}`}>{item}</ListItem>
                                ))}
                            </List>
                        </Card>
                    ))}
                </DesktopGrid>

                <MobileAccordionContainer>
                    <PrimaryAccordion variant="dark" items={mobileAccordionItems} headerFontSize={22} />
                </MobileAccordionContainer>
            </EquipmentWrapper>
        </BaseWrapper>
    );
};

export default Equipment;
